import PropTypes from 'prop-types';

export default function ScrollTop({ children }) {
  return children || null;
}

ScrollTop.propTypes = { children: PropTypes.oneOfType([PropTypes.any, PropTypes.node]) };
